<p>
  {{
    'sharedModule.bkgVehicleDialogSelectClientCar.selectVehicleSubtitle'
      | translate
  }}
</p>

<form [formGroup]="clientCarForm" class="modal__section form-compact">
  <div class="form-group">
    <label for="vehicle" class="sr-only">
      {{
        'sharedModule.bkgVehicleDialogSelectClientCar.selectVehicle' | translate
      }}
      <div
        *ngIf="loadingVehicles"
        class="blue-spinner__small loading__spinner"
      ></div>
    </label>
    <ng-select
      #selectId
      (change)="selectId.blur()"
      formControlName="id"
      id="vehicle"
      [clearable]="false"
      [searchable]="false"
      placeholder="{{
        'sharedModule.bkgVehicleDialogSelectClientCar.selectVehicle' | translate
      }}"
      controlErrorsClass="info-field--warning"
      [appendTo]="'body'"
    >
      <ng-option *ngFor="let v of vehicles" [value]="v.id"
        >{{ v.plate }}
        {{
          v.vehicle_information && v.vehicle_information.make_description
            ? '- ' +
              v.vehicle_information.make_description +
              ' ' +
              v.vehicle_information.model_description
            : v.type
        }}</ng-option
      >
    </ng-select>
  </div>

  <p *ngIf="!addMoreInfoClient">
    <a class="link" (click)="addNewVehicle()">
      {{
        'sharedModule.bkgVehicleDialogSelectClientCar.addNewVehicle' | translate
      }}</a
    >
  </p>

  <button
    *ngIf="!addMoreInfoClient"
    class="btn-primary btn-large is-block"
    [disabled]="clientCarForm.invalid"
    (click)="selectVehicle()"
  >
    {{ 'sharedModule.bkgVehicleDialogSelectClientCar.agree' | translate }}
  </button>
</form>
